<template lang="html">
  <div class="contact-message">

    <div class="container">
      <div class="row"> <!-- Titulo -->
        <h2 class="title">{{$t('telas.contato.titulo')}}</h2>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12
                    col-md-8 offset-md-2
                    col-lg-8 offset-lg-2
                    col-xl-8 offset-xl-2">
          <div class="content-contact-message">
            <div class="title-div-contact-message">
              <h4>{{$t('telas.contato.descricao.msg.titulo')}}</h4>
            </div>
            <hr>
            <form class="form-contact-message">

              <div class="row row-form">
                <div class="col">
                  <label for="nome">* {{$t('telas.contato.descricao.msg.nome')}}</label>
                  <input type="text" id="nome" v-model="msg.nome" class="form-control" :placeholder="$t('telas.contato.descricao.msg.placeholder_nome')" required autocomplete="off">
                </div>
              </div>

              <div class="row row-form">
                <div class="col">
                  <label for="pais">{{$t('telas.contato.descricao.msg.pais')}}</label>
                  <select class="custom-select" id="pais" v-model="msg.pais">
                    <option v-for="i in list.countries"> {{ i.name }} </option>
                  </select>
                </div>

                <div class="col">
                  <label for="cidade">{{$t('telas.contato.descricao.msg.cidade')}}</label>
                  <input type="text" id="cidade" v-model="msg.cidade" class="form-control" :placeholder="$t('telas.contato.descricao.msg.cidade')" autocomplete="off">
                </div>
              </div>

              <div class="row row-form">
                <div class="col">
                  <label for="email">* {{$t('telas.contato.descricao.msg.email')}}</label>
                  <input type="text" id="email" v-model="msg.email" class="form-control" :placeholder="$t('telas.contato.descricao.msg.placeholder_email')" required>
                </div>

                <div class="col">
                  <label for="telefone">{{$t('telas.contato.descricao.msg.telefone')}}</label>
                  <input type="text" id="telefone" v-model="msg.telefone" class="form-control" :placeholder="$t('telas.contato.descricao.msg.telefone')" autocomplete="off">
                </div>
              </div>

              <div class="row row-form">
                <div class="col">
                  <label for="assunto">* {{$t('telas.contato.descricao.msg.assunto')}}</label>
                  <input type="text" id="assunto" v-model="msg.assunto" class="form-control" :placeholder="$t('telas.contato.descricao.msg.assunto')" required autocomplete="off">
                </div>
              </div>

              <div class="row row-form">
                <div class="col">
                  <label for="mensagem">* {{$t('telas.contato.descricao.msg.mensagem')}}</label>
                  <textarea id="mensagem" v-model="msg.msg" class="form-control" rows="5" :placeholder="$t('telas.contato.descricao.msg.placeholder_mensagem')" required autocomplete="off"></textarea>
                </div>
              </div>

              <div class="btn-alert-contact-message">
                <p>
                  <!-- <input type="submit" @click.stop="sendMessage()" class="btn btn-info" value="Enviar"> -->
                  <button type="submit" @click.stop="sendMessage()" class="btn btn-info btn-send-message">{{$t('telas.contato.botao.enviar')}}</button>
                </p>

                <div class="alert alert-success alert-message" id="alert-success-evaluation" role="alert">
                  <strong>{{$t('telas.contato.descricao.msg.mensagem_enviada')}}, {{ msg.nome }}! {{$t('telas.contato.descricao.msg.agradecimento')}}</strong>
                </div>

                <div class="alert alert-danger alert-message" id="alert-error-evaluation" role="alert">
                  <strong>{{$t('telas.contato.descricao.msg.mensagem_erro')}}</strong>
                </div>

              </div>

            </form>
          </div>
        </div>
      </div> <!-- row -->

      <!-- reserva -->
      <reserva :header="true"></reserva>

    </div> <!-- Container -->
  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
import countriesList from 'countries-list'

export default {
  name: 'Contact',

  data() {
    return {
      list: countriesList, // list of countries
      msg: {
        nome: '',
        pais: 'Brazil',
        cidade: '',
        email: '',
        telefone: '',
        msg: '',
        assunto: ''
      }
    };
  },

  components: {
    reserva
  },

  methods: {
    async sendMessage() {
      try {
        if (this.msg.nome != '' && this.msg.email != '' && this.msg.msg != '' && this.msg.assunto != '') {
          let obj = {
            name: this.msg.nome,
            country: this.msg.pais,
            email: this.msg.email,
            message: this.msg.msg,
            city: this.msg.cidade,
            phone: this.msg.telefone,
            subject: this.msg.assunto
          }

          // let prepareMessage = utils.prepareJson(obj)
          // let resMessage = await this.$req.contact.requestPost(null, prepareMessage)
          this.showSucess()
        }
      } catch (err) {
        console.error(err)
        this.showError()
      }
    },

    showSucess() {
      document.getElementById('alert-success-evaluation').style.display = 'block'

      this.msg.pais = 'Brazil'
      this.msg.cidade = ''
      this.msg.email = ''
      this.msg.telefone = ''
      this.msg.msg = ''
      this.msg.assunto = ''

      setTimeout(() => {
          document.getElementById('alert-success-evaluation').style.display = 'none'
          this.msg.nome = ''
        }, 8000
      );
    },
    showError() {
      document.getElementById('alert-error-evaluation').style.display = 'block'
      
      setTimeout(() => {
          document.getElementById('alert-error-evaluation').style.display = 'none'
        }, 8000
      );
    }
  }
}
</script>

<style lang="css">
.contact-message {
  /* background-color: #EFEFEF; */
  background-image: url('../../assets/img/bg.png');
  background-repeat: repeat;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.contact-message .container .row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  margin-bottom: 40px;
}

.contact-message .container .row .content-contact-message {
  background-color: rgb(23, 162, 184);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.contact-message .container .row .content-contact-message .title-div-contact-message {
  width: 100%;
}
.contact-message .container .row .content-contact-message .title-div-contact-message h4 {
  text-align: center;
  margin-top: 10px;
  color: white;
}
.contact-message .container .row .content-contact-message form.form-contact-message .row-form label,
.contact-message .container .row .evaluation .content-contact-message h1,
.contact-message .container .row .evaluation .content-contact-message h4,
.contact-message .container .row .evaluation .content-contact-message p {
  color: white;
}
.contact-message .container .row .content-contact-message textarea {
  resize: none;
}
.contact-message .container .row form .row-form {
  margin-bottom: 10px;
}

.contact-message .container .row form .btn-alert-contact-message {
   width: 100%
}
.contact-message .container .row form .btn-alert-contact-message p {
   text-align: center;
}
.contact-message .container .row form .btn-alert-contact-message .alert-message {
  display: none;
  transition: display 1s;
}

.contact-message .container .row .evaluation h1 {
  margin: 0;
}
.contact-message .container .row .evaluation p {
  margin: 0;
}
.btn-send-message {
  width: 100%;
  background-color: rgb(0, 38, 62)
}
</style>



// WEBPACK FOOTER //
// src/pages/contact/Contact.vue